// This is just a list of our error codes we may use when an HTTP request fails.
export const codes = {
  dark_reads: {
    mismatch: 'dark_reads_mismatch',
    mismatch_count: 'dark_reads_mismatch_count',
    gsi_recent_mismatch: 'dark_reads_gsi_recent_mismatch',
  },
  request: {
    incompatible_filters: `incompatible_filters`,
    no_update_provided: `no_update_provided`,
    no_txs_provided: `no_txs_provided`,
    too_many_txs: `too_many_txs`,
    concurrent_request_conflict: `concurrent_request_conflict`,
    too_many_items_in_list_filter: `too_many_items_in_list_filter`,
    invalid_input_provided: `invalid_input_provided`,
    amount_must_be_integer: `amount_must_be_integer`,
    period_filter_day_not_supported: `period_filter_day_not_supported`,
    unsupported_period_filter: `unsupported_period_filter`,
    bad_cursor: 'bad_cursor',
    invalid_page_size: 'request_invalid_page_size',
  },
  balances: {
    invalid_duration: `invalid_duration`,
    invalid_time_range: `invalid_time_range`,
    unsupported_period_type: `unsupported_period_type`,
    currency_mismatch: `currency_mismatch`,
    multi_currency_account_missing_currency: `multi_currency_account_missing_currency`,
    granularity_not_supported: `granularity_not_supported`,
    failed_to_get_balance_docs: `failed_to_get_balance_docs`,
    historical_balances_disabled: `historical_balances_disabled`,
  },
  ik: {
    request_body_mismatch: 'ik_request_body_mismatch',
    concurrent_reverse_ledger_entry_request:
      'ik_concurrent_reverse_ledger_entry_request',
    repost_not_enabled: 'ik_repost_not_enabled',
    duplicate_ik_in_batch: 'ik_duplicate_ik_in_batch',
    reserved_prefix: 'ik_reserved_prefix',
    too_long: 'ik_too_long',
  },
  ledger: {
    not_found: 'ledger_not_found',
    not_provided: 'ledger_not_provided',
    recently_deleted: 'ledger_recently_deleted',
    migration_in_progress: 'ledger_migration_in_progress',
    version_conflict: 'ledger_version_conflict',
    delete_failed: 'ledger_delete_failed',
    delete_in_production: 'ledger_delete_in_production',
    missing_modified_timestamp: 'ledger_missing_modified_timestamp',
    invalid_name: 'ledger_invalid_name',
    name_too_long: 'ledger_name_too_long',
  },
  ledger_account: {
    not_found: 'ledger_account_not_found',
    not_templated: 'ledger_account_not_templated',
    invalid_path: 'ledger_account_invalid_path',
    incorrect_ledger: 'ledger_account_incorrect_ledger',
    disabled_status: `ledger_account_disabled`,
    archived_status: `ledger_account_archived`,
    multiple_categories: 'ledger_account_multiple_categories',
  },
  payment: {
    too_many_attempts: 'payment_too_many_attempts',
    already_accepted: 'payment_already_accepted',
    no_attempt_to_retry: 'payment_no_attempt_to_retry',
    attempt_in_progress: 'payment_attempt_in_progress',
    attempt_changed: 'payment_attempt_changed',
    method_required: 'payment_method_required',
    account_not_verified: 'payment_account_not_verified',
    amount_below_minimum: 'payment_amount_below_minimum',
    amount_above_maximum: 'payment_amount_above_maximum',
    amount_too_large: 'payment_amount_too_large',
    schema_key_not_found: 'payment_schema_key_not_found',
    type_not_found: 'payment_type_not_found',
    missing_parameters: 'payment_missing_parameters',
    unknown_parameters: 'payment_unknown_parameters',
    reserved_parameters: 'payment_reserved_parameters',
    invalid_request: 'payment_invalid_request',
    not_refundable: 'payment_not_refundable',
    refund_amount_too_large: 'payment_refund_amount_too_large',
  },
  payment_method: {
    invalid_id: 'payment_method_invalid_id',
    not_found: 'payment_method_not_found',
    expired: 'payment_method_expired',
  },
  payment_method_setup: {
    invalid_id: 'payment_method_setup_invalid_id',
    not_found: 'payment_method_setup_not_found',
    invalid_request: 'payment_method_setup_invalid_request',
    confirmation_rejected: 'payment_method_setup_confirmation_rejected',
  },
  payment_account: {
    not_provisioned: 'payment_account_not_provisioned',
    direct_posting_disallowed: `payment_account_direct_posting_disallowed`,
    only_with_schema: 'payment_account_only_with_schema',
    not_jit_allowed: 'payment_account_not_jit_allowed',
    not_found: 'payment_account_not_found',
  },
  payment_entry: {
    cannot_reverse: 'payment_entry_cannot_reverse',
    cannot_migrate: 'payment_entry_cannot_migrate',
    cannot_update: 'payment_entry_cannot_update',
  },
  ledger_entry: {
    invalid_id_provided: `ledger_entry_invalid_id_provided`,
    not_found: `ledger_entry_not_found`,
    too_many_lines: `ledger_entry_too_many_lines`,
    too_many_batch_lines: `ledger_entry_too_many_batch_lines`,
    not_provided: `ledger_entry_not_provided`,
    schema_key_not_found: `ledger_entry_schema_key_not_found`,
    update_version_mismatch: `ledger_entry_update_version_mismatch`,
    already_reversed: `ledger_entry_already_reversed`,
    reversal_linked_account_not_supported: `ledger_entry_reversal_linked_account_not_supported`,
    invalid_entry_version: `ledger_entry_invalid_entry_version`,
    recently_reversed: `ledger_entry_recently_reversed`,
    conflicting_tag_update: `ledger_entry_conflicting_tag_update`,
    tags_not_provided: `ledger_entry_tags_not_provided`,
    groups_not_provided: `ledger_entry_groups_not_provided`,
    migration_not_allowed: `ledger_entry_migration_not_allowed`,
    entry_type_disabled: `ledger_entry_entry_type_disabled`,
    entry_cannot_have_multiple_pre_or_postconditions_on_same_account: `ledger_entry_entry_cannot_have_multiple_pre_or_postconditions_on_same_account`,
    no_lines: `ledger_entry_no_lines`,
    too_many_transaction_items: `ledger_entry_too_many_transaction_items`,
    duplicate_tx_reconciliation_in_batch: `ledger_entry_duplicate_tx_reconciliation_in_batch`,
    reverse_and_reconcile_in_batch: `ledger_entry_reverse_and_reconcile_in_batch`,
    batch_aborted_by_peer_condition: `ledger_entry_batch_aborted_by_peer_condition`,
    batch_rolled_back_by_peer: `ledger_entry_batch_rolled_back_by_peer`,
    unsatisfiable_batch_condition: `ledger_entry_unsatisfiable_batch_condition`,
    batch_operation_failed: `ledger_entry_batch_operation_failed`,
  },
  ledger_entry_history: {
    no_history_for_ik: `no_ledger_entry_history_for_ik`,
  },
  ledger_line: {
    not_found: `ledger_line_not_found`,
    invalid_line_key: `ledger_line_invalid_line_key`,
    not_provided: `ledger_line_not_provided`,
    tags_not_provided: `ledger_line_tags_not_provided`,
    conflicting_tag_update: `ledger_line_conflicting_tag_update`,
    duplicate_line_update: `ledger_line_duplicate_line_update`,
  },
  schema: {
    not_found: 'schema_not_found',
    entry_type_not_found: 'schema_entry_type_not_found',
    max_size_exceeded: 'schema_max_size_exceeded',
    payments_not_enabled: 'payments_not_enabled',
    refunds_not_enabled: 'refunds_not_enabled',
    production_schema_limit: 'production_schema_limit',
    production_payment_ledger_limit: 'production_payment_ledger_limit',
  },
  schema_ledger: {
    not_found: 'schema_ledger_not_found',
  },
  external_account: {
    not_found: `external_account_not_found`,
  },
  invites: {
    invalid_invite: `invalid_invite`,
    expired: `invite_expired`,
    delete_used_invite: `delete_used_invite`,
    no_invites: `no_invites`,
    too_many_invites: `too_many_invites`,
    inviting_existing_member: `inviting_existing_member`,
  },
  link: {
    not_found: `link_not_found`,
    unit_not_supported: `link_unit_not_supported`,
  },
  tx: {
    tx_max_reconciled_entries: `tx_max_reconciled_entries`,
    missing_currency: `tx_missing_currency`,
    missing_account: `tx_missing_account`,
    invalid_posted_value: `tx_invalid_posted_value`,
    external_id_too_long: `tx_external_id_too_long`,
    description_empty: `tx_description_empty`,
    description_too_long: `tx_description_too_long`,
    reconciliation_disallowed: `tx_reconciliation_disallowed`,
    has_reconciled_ledger_entries: `tx_has_reconciled_ledger_entries`,
    not_found: `tx_not_found`,
    already_reconciled: `tx_already_reconciled`,
  },
  sync_custom_txs: {
    received_duplicate_tx_external_ids: `received_duplicate_tx_external_ids`,
  },
  add_ledger_entry: {
    linked_accounts_disallowed: `linked_accounts_disallowed`,
  },
  migrate_ledger_entry: {
    ledger_mismatch: `migrate_ledger_entry_ledger_mismatch`,
  },
  reconcile_tx: {
    invalid_posted_timestamp: `invalid_posted_timestamp`,
    no_tx_lines_provided: `no_tx_lines_provided`,
    too_many_tx_lines_provided: `too_many_tx_lines_provided`,
    invalid_ledger_account: `invalid_ledger_account`,
  },
  billing: {
    invoice_service_unavailable: 'invoice_service_unavailable',
  },
  data_export: {
    connection_failed: 'data_export_connection_failed',
  },
  custom_currency: {
    name_empty: 'custom_currency_name_empty',
    id_empty: 'custom_currency_id_empty',
    code_empty: 'custom_currency_code_empty',
    id_too_long: 'custom_currency_id_too_long',
    code_too_long: 'custom_currency_code_too_long',
    precision_must_be_non_negative:
      'custom_currency_precision_must_be_non_negative',
    name_too_long: 'custom_currency_name_too_long',
  },
  payments_onboarding: {
    business_cdd_not_found: 'business_cdd_not_found',
    business_entity_not_found: 'payments_onboarding_business_entity_not_found',
    bt_token_update_failed: 'payments_onboarding_bt_token_update_failed',
    entity_missing_pii_token: 'payments_onboarding_entity_missing_pii_token',
    entity_not_found: 'payments_onboarding_entity_not_found',
    entity_not_submittable: 'payments_onboarding_entity_not_submittable',
    entity_type_mismatch: 'payments_onboarding_entity_type_mismatch',
    entity_type_not_supported: 'payments_onboarding_entity_type_not_supported',
    invalid_prong: 'payments_onboarding_invalid_prong',
    missing_api_keys: 'payments_onboarding_missing_api_keys',
    missing_oscilar_endpoint_url:
      'payments_onboarding_missing_oscilar_endpoint_url',
    oscilar_submission_failed: 'payments_onboarding_oscilar_submission_failed',
  },
  authorizer: {
    workspace_access_not_found: 'authorizer_workspace_access_not_found',
    workspace_access_ambiguous: 'authorizer_workspace_access_ambiguous',
  },
  workspace: {
    workspace_not_found: 'workspace_not_found',
    already_exists: 'workspace_already_exists',
    free_tier_entry_limit: 'workspace_free_tier_entry_limit',
    type_not_allowed: 'workspace_type_not_allowed',
    parent_required: 'workspace_parent_required',
    parent_not_found: 'workspace_parent_not_found',
    parent_access_needed: 'workspace_parent_access_needed',
    parent_not_paid: 'workspace_parent_not_paid',
    parent_stripe_customer_missing: 'workspace_parent_stripe_customer_missing',
  },
  workspace_access: {
    already_exists: 'workspace_access_already_exists',
  },
  workspace_member: {
    cap_limit_exceeded: 'cap_limit_exceeded',
  },
  api_client: {
    invalid_role: 'api_client_invalid_role',
  },
  user: {
    user_not_found: 'user_not_found',
    user_not_belong_to_workspace: 'user_not_belong_to_workspace',
    user_cannot_change_own_role: 'user_cannot_change_own_role',
    role_not_assignable: 'role_not_assignable',
    invalid_email: 'user_invalid_email',
  },
  conditional_request_failed: 'conditional_request_failed',
  parameterization_failed: 'parameterization_failed',
  schema_not_found: 'schema_not_found',
  not_authorized: 'not_authorized',
  role_exceeds_granter: 'role_exceeds_granter',
  throttling_error: 'throttling_error',
};

export const internalErrorCodes = {
  line_missing_in_entry_schema: 'line_missing_in_entry_schema',
  account_missing_in_schema_chart: 'account_missing_in_schema_chart',
  ledger_account_schema_not_found: 'ledger_account_schema_not_found',
  loader_empty_table_array: 'loader_empty_table_array',
  loader_key_missing_table: 'loader_key_missing_table',
  loader_key_wrong_table: 'loader_key_wrong_table',
  elastic_filter_mismatch: 'elastic_filter_mismatch',
  auth_policy_duplicate_for_principal: 'auth_policy_duplicate_for_principal',
  workspace_access_query_no_response: 'workspace_access_query_no_response',
  internal_api_error: 'internal_api_error',
  // Authenticated request context was missing a field the auth/gate layer
  // should have populated before a command ran.
  workspace_id_missing_from_context: 'workspace_id_missing_from_context',
  request_user_id_missing_from_context: 'request_user_id_missing_from_context',
  principal_id_missing_from_context: 'principal_id_missing_from_context',
  command_gate_missing_shield_rule: 'command_gate_missing_shield_rule',
  auth_gate_unexpected_error: 'auth_gate_unexpected_error',
  auth_gate_missing_authorization_context:
    'auth_gate_missing_authorization_context',
  resolved_ledger_doc_match_mismatch: 'resolved_ledger_doc_match_mismatch',
  // Search client construction failed on config the stack should have supplied.
  search_api_key_missing: 'search_api_key_missing',
  search_index_template_not_found: 'search_index_template_not_found',
  opensearch_region_missing: 'opensearch_region_missing',
  opensearch_role_arn_prefix_missing: 'opensearch_role_arn_prefix_missing',
  opensearch_permission_has_no_fgac_tier:
    'opensearch_permission_has_no_fgac_tier',
  opensearch_assume_role_incomplete_credentials:
    'opensearch_assume_role_incomplete_credentials',
};
